export const isCMDBEnabledInEnvironment = (): boolean => true;
